import { useRef, useState, useCallback, useEffect } from 'react'

const KSWorkerDebugViewModel = () => {
    
    const workerRef = useRef(null)
    const [file, setFile] = useState(null)
    
    const splitPdfFile = useCallback(async sourceFile => {
        
        console.log('splitPdfFile', sourceFile.name)
        const pdfWorker = workerRef.current
        const canvas = new OffscreenCanvas(600, 800)
        const fileReader = new FileReader()
        
        fileReader.onload = () => {
            
            const arrayBuffer = fileReader.result
            
            console.log('sending fileReader result', arrayBuffer)
            
            pdfWorker.postMessage({
                pdfData: arrayBuffer,
                canvas,
            }, [arrayBuffer, canvas])
            
        }
        
        fileReader.readAsArrayBuffer(sourceFile)
        
    }, [workerRef])
    
    const onFileChange = async e => {
        
        const nextFile = e.target.files[0]
        
        setFile(nextFile)
        await splitPdfFile(nextFile)
        
    }
    
    useEffect(() => {
        
        // Initialize the web worker
        // workerRef.current = new Worker('/KSWorkerDebugWorker.js')
        workerRef.current = new Worker(
            new URL('./KSWorkerDebugWorker.js', import.meta.url),
            { type: 'module' })
        
        // Clean up the worker when component unmounts
        return () => {
            
            if (workerRef.current)
                workerRef.current.terminate()
            
        }
        
    }, [])
    
    return {
        file,
        setFile,
        splitPdfFile,
        onFileChange,
    }
    
}

export default KSWorkerDebugViewModel
